// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ReportKind,
} from "./types";

export default {
  get kind() {
    return ReportKind;
  },
  summary: __t.string(),
  description: __t.string(),
  systemInfo: __t.string(),
  includeScreenshot: __t.bool(),
  includeLog: __t.bool(),
  reporterDisplayName: __t.string(),
  reporterEmail: __t.string(),
  reporterOrgName: __t.string(),
  reporterProjectName: __t.string(),
  reporterProjectId: __t.string(),
};
